import { MoreOutlined, SearchOutlined, SyncOutlined, PrinterOutlined } from '@ant-design/icons';
import { Button, Drawer, Dropdown, Input, Layout, Menu, Modal, Space, Table, Tag, theme, message } from "antd";
import { Header } from "antd/es/layout/layout";
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Link, useNavigate } from "react-router-dom";
import Footers from "../components/Footer";
import Headers from "../components/Header";
import StatСancels from "../components/Map/StatCancel";
import StatMasa from "../components/Map/StatMasa.js";
import StatUSer from "../components/Map/StatUser.js";
import Tabbar from "../components/Tabbar";
import logo from "../images/logo.png";
import MapC from "../components/Map/Map";
import MapM2 from "../components/Map/MapM2";
import { ref, remove, onValue } from "firebase/database";
import { getDatabase, set, get } from "firebase/database";
import { database } from "../firebaseConfig"; // Firebase initialized here
import QueueList from '../components/Map/QueueList.js';
import MapEurope from '../components/Map/MapEurop.js';

const { Content } = Layout;
const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;

axios.interceptors.request.use((config) => {
    if (config.url.includes('WebReserv/getBills.php')) {
        // Only modify headers for this specific endpoint
        config.headers = {
            ...config.headers,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
    }
    return config;
});

function Mapmain() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [userLevel, setUserLevel] = useState('');
    const [open, setopen] = useState(false);
    const [isModalopen, setIsModalopen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedReason, setSelectedReason] = useState(''); // Define selectedReason state
    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [permissions, setPermissions] = useState({});
    const [onlineCount, setOnlineCount] = useState(0);
    const [offlineCount, setOfflineCount] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null); // State for the selected row
    const [orders, setOrders] = useState([]);
    const [isOrdersModalVisible, setIsOrdersModalVisible] = useState(false);
    const [selectedBillId, setSelectedBillId] = useState(null);
    const [printHistory, setPrintHistory] = useState([]);

    // Add this after your other Firebase imports
    const printHistoryRef = ref(database, 'printHistory');

    useEffect(() => {
        // Reference the Firebase Realtime Database
        const sessionsRef = ref(database, "sessions"); // Path to the 'sessions' node

        // Listen for changes in the 'sessions' node
        const unsubscribe = onValue(sessionsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();

                // Flatten all sessions into an array
                const allSessions = Object.values(data).flatMap((session) =>
                    typeof session === "object" ? Object.values(session) : []
                );

                // Calculate counts based on `isOnline` status
                const onlineSessions = allSessions.filter((session) => session.isOnline === true).length;
                const offlineSessions = allSessions.filter((session) => session.isOnline === false).length;

                // Update state with counts
                setOnlineCount(onlineSessions);
                setOfflineCount(offlineSessions);
            } else {
                // Reset counts if no data exists
                setOnlineCount(0);
                setOfflineCount(0);
            }
        });

        // Cleanup listener on component unmount
        return () => unsubscribe();
    }, []);
    useEffect(() => {
        // Fetch permissions from session storage
        const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
        console.log('Stored Permissions:', storedPermissions);

        if (storedPermissions && storedPermissions.length > 0) {
            setPermissions(storedPermissions[0]);
        }

        // Check if GuidesAzAdd permission is 0 and navigate if true
        if (storedPermissions && storedPermissions[0].Rezerv === 0) {
            navigate("/");
        }
    }, []);
    useEffect(() => {
        fetchData();
        fetchDatafirabase();
        const intervalId = setInterval(fetchData, 2000);
        return () => clearInterval(intervalId);
    }, []);

    const onClose = () => {
        setopen(false);
    };

    const getCurrentDateInBaku = () => {
        const now = new Date();
        const offset = 4 * 60 * 60 * 1000; // UTC+4
        const bakuTime = new Date(now.getTime() + offset);
        return bakuTime.toISOString().split("T")[0];
    };

    const resolveFirebasePath = (Masa, selectedFlourId) => {
        if (selectedFlourId.startsWith("L") || selectedFlourId.startsWith("B") || selectedFlourId.startsWith("R")) {
            return `reservationsL2/${Masa}`;
        } else if (selectedFlourId.startsWith("M")) {
            return `reservationsMM/${Masa}`;
        } else if (selectedFlourId.startsWith("EU")) {
            return `reservationsEurop/${Masa}${selectedFlourId}`;
        } else {
            return null;
        }
    };

    const fetchData = async () => {
        try {
            const phpResponse = await axios.get(`${CONN_KEY}app123/printrezervs.php`);
            const phpReservations = phpResponse.data.reservations || [];

            if (phpReservations.length === 0) {
                console.warn("No reservations returned from PHP API.");
                setData([]);
                setIsLoading(false);
                return;
            }

            setData(phpReservations); // All data, unfiltered
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching PHP data:", error);
            setIsLoading(false);
        }
    };

    const fetchDatafirabase = async () => {
        try {
            const currentDate = getCurrentDateInBaku();
            const phpResponse = await axios.get(`${CONN_KEY}app123/printrezervsEurope.php`);
            const phpReservations = phpResponse.data.reservations || [];

            const filteredReservations = phpReservations.filter(res =>
                new Date(res.selectedDay).toISOString().split("T")[0] === currentDate
            );

            const db = getDatabase();

            for (const reservation of filteredReservations) {
                const { Masa, note, selectedDay, selectedTime, selectedFlourId, status, userId } = reservation;

                const path = resolveFirebasePath(Masa, selectedFlourId);
                if (!path) {
                    console.warn(`Unrecognized selectedFlourId "${selectedFlourId}". Skipping Masa "${Masa}".`);
                    continue;
                }

                const reservationRef = ref(db, path);
                const payload = {
                    Masa: selectedFlourId.startsWith("EU") ? `${Masa}${selectedFlourId}` : Masa,
                    note: note || "",
                    selectedDay,
                    selectedFlourId,
                    selectedTime,
                    status,
                    userId: String(userId),
                };

                try {
                    await set(reservationRef, payload);
                    console.log(`✅ Updated Firebase: ${path}`, payload);
                } catch (err) {
                    console.error(`❌ Error writing to ${path}:`, err.message);
                }
            }

            setIsLoading(false);
        } catch (error) {
            console.error("Error syncing to Firebase:", error.message);
            setIsLoading(false);
        }
    };

    const sendToFirebase = async () => {
        if (!selectedRow) {
            alert("Please select a row first.");
            return;
        }

        const { Masa, selectedFlourId } = selectedRow;
        const path = resolveFirebasePath(Masa, selectedFlourId);
        if (!path) {
            console.warn(`Unrecognized selectedFlourId: "${selectedFlourId}"`);
            return;
        }

        try {
            const db = getDatabase();
            const reservationRef = ref(db, path);
            await set(reservationRef, selectedRow);
            alert("Selected reservation sent to Firebase successfully.");
            console.log("✅ Manual Firebase write:", selectedRow);
        } catch (error) {
            console.error("Error sending to Firebase:", error.message);
            alert("Failed to send data to Firebase.");
        }
    };

    const deleteFirebaseReservation = async (masa, selectedFlourId) => {
        const path = resolveFirebasePath(masa, selectedFlourId);
        if (!path) {
            console.warn(`Unrecognized selectedFlourId "${selectedFlourId}". Cannot delete.`);
            return;
        }

        try {
            const db = getDatabase();
            await remove(ref(db, path));
            console.log(`🗑️ Deleted reservation from Firebase: ${path}`);
        } catch (error) {
            console.error("Error deleting reservation from Firebase:", error.message);
        }
    };

    const isNotTodayOrAfterEndDay = (record) => {
        const today = new Date();
        const date = new Date(record.created_at);

        // Assuming endDay is a property in the record
        const endDay = record.endDay;

        return today.toDateString() !== date.toDateString() || (endDay && today > new Date(endDay));
    };
    useEffect(() => {
        // Fetch user level from local storage
        const storedUserLevel = localStorage.getItem('s');
        if (storedUserLevel) {
            setUserLevel(storedUserLevel);
        }
    }, []);
    const rowClassName = (record) => {
        const isDisabled = isNotTodayOrAfterEndDay(record);

        return isDisabled ? "grayscale disabled" : "";
    };
    const navigate = useNavigate();

    const isNotToday = (dateString) => {
        const currentDate = getCurrentDateInBaku();
        const targetDate = new Date(dateString).toISOString().split("T")[0];
        return currentDate !== targetDate;
    };

    const handlePermisson = (record) => {
        if (record.status === "cancelled") {
            console.log("This reservation is already cancelled. The modal won't be opened.");
            return; // Do not open the modal if the status is "cancelled"
        }

        setSelectedRecord(record);
        setIsModalopen(true);
        setSelectedReason(''); // Reset selectedReason when opening the modal
    };

    const handleModalSubmit = async (sebeb) => {
        try {
            // Retrieve the username from local storage
            const username = localStorage.getItem('username');

            // Define the API endpoint
            const endpoint = `${CONN_KEY}app123/permission.php`;

            // Create the request data object, including the selected record ID, reason, and username
            const requestData = {
                reservationId: selectedRecord.reservationId,
                userId: selectedRecord.userId,
                sebeb: sebeb,
                maneger: username, // Corrected to match the expected parameter name
            };

            // Send the POST request using axios
            const response = await axios.post(endpoint, requestData);

            // Log the API response
            console.log("API Response:", response.data);

            // If the reservation cancellation is successful, delete the corresponding reservation from Firebase
            if (response.data.message === "Reservation cancellation successful.") {
                deleteFirebaseReservation(selectedRecord.Masa, selectedRecord.selectedFlourId);
            }

            // Close the modal and fetch updated data
            setIsModalOpen(false); // Close the modal
            fetchData(); // Fetch updated data
        } catch (error) {
            console.error("Error in handleModalSubmit:", error);
            // Handle error appropriately, e.g., show an error message to the user
        }
    };


    const canSeeSectionsRezervCancel = permissions.RezervCancel === 1;


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndices) => {
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Search ${dataIndices.join(', ')}`}
                        value={selectedKeys[0]}
                        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndices)}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndices)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Search
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Reset
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => (
                <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) => {
                return dataIndices.some((dataIndex) => {
                    const columnValue = record[dataIndex];
                    return columnValue
                        ? columnValue.toString().toLowerCase().includes(value.toLowerCase())
                        : false;
                });
            },
            onFilterDropdownOpenChange: (open) => {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
            render: (text, record) => (
                dataIndices.map((dataIndex) => {
                    const textToHighlight = record[dataIndex]?.toString() || '';
                    return searchedColumn === dataIndex ? (
                        <Highlighter
                            key={dataIndex}
                            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                            searchWords={[searchText]}
                            autoEscape
                            textToHighlight={textToHighlight}
                        />
                    ) : (
                        <span>{textToHighlight}</span>
                    );
                })
            ),
        };
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: ['username', 'surename'],
            key: 'name',
            fixed: 'left',
            width: 150,
            ...getColumnSearchProps(['username', 'surename']),
            render: (text, record) => (
                <a href={`/PDF/${record.userid}`}>
                    <p>{record.username}  {record.surename}</p>
                </a>
            ),
        },
        {
            title: 'Masa',
            dataIndex: 'Masa',
            key: 'Masa',
            ...getColumnSearchProps(['Masa']),
        },
        {
            title: 'Mərtəbə Ərazi',
            dataIndex: 'selectedFlourId',
            key: 'selectedFlourId',
            ...getColumnSearchProps(['selectedFlourId']),
            width: 100,
        },
        {
            title: 'R Tarix / Saat',
            dataIndex: 'selectedDay',
            key: 'selectedDay',
            width: 100,
            render: (text, record) => {
                const date = new Date(text);
                return (
                    <div>
                        <p>{date.toLocaleDateString('en-GB')} {record.selectedTime}</p>
                    </div>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (text) => (
                <Tag color={text === "pending" ? "yellow" : text === "complete" ? "green" : "red"}>
                    {text}
                </Tag>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            width: 110,
            ...getColumnSearchProps(['created_at']),
            key: '75654',
            render: (text) => {
                const date = new Date(text);
                return date.toLocaleString('en-GB', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            },
        },
        {
            title: "More",
            key: "more",
            width: 50,
            fixed: "right",
            render: (_, record) => {
                const items = [
                    {
                        key: "Permission",
                        label: "Permission",
                        onClick: () => handlePermisson(record),
                    },
                ];

                return (
                    <Dropdown menu={{ items }} trigger={["click"]}>
                        {/* children MÜTLƏQ tək element olmalıdır */}
                        <Button icon={<MoreOutlined />} />
                    </Dropdown>
                );
            },
        },
        {
            title: 'Orders',
            key: 'orders',
            fixed: 'right',
            width: 100,
            render: (_, record) => (
                <Button
                    onClick={() => getOrders(record.id)}
                    type="primary"
                >
                    View Orders
                </Button>
            ),
        },
    ];

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams((prevParams) => ({
            ...prevParams,
            pagination,
        }));
    };
    const handlePrintExtra = () => {
        // Open a new window
        const popupWindow = window.open('/printpage', '_blank', 'width=1200,height=900');

        // Check if the element with id 'printpage' exists
        const printPageElement = document.getElementById('printpage');
        if (printPageElement) {
            // Create a div for the printed content
            const printContainer = document.createElement('div');

            // Clone the content of the 'printpage' element
            printContainer.innerHTML = printPageElement.innerHTML;

            // Add the date information
            const printDateDiv = document.createElement('div');
            printDateDiv.innerHTML = `<p style="text-align: center; bottom:10px;">Printed on: ${new Date().toLocaleString()} By Marketing | VERSİON: 1.0.1</p>`;
            printContainer.appendChild(printDateDiv);

            // Replace 'printContents' with 'originalContents'
            const originalContents = document.body.innerHTML;
            document.body.innerHTML = printContainer.innerHTML;

            // Print the new content
            popupWindow.print();

            // Restore the original content
            document.body.innerHTML = originalContents;

            // Close the popup window
            popupWindow.document.close();
        }
    };
    const handlePrintEllips = () => {
        // Open a new window
        const popupWindow = window.open('/printpageEllips', '_blank', 'width=1200,height=900');

        // Check if the element with id 'printpage' exists
        const printPageElement = document.getElementById('printpage');
        if (printPageElement) {
            // Create a div for the printed content
            const printContainer = document.createElement('div');

            // Clone the content of the 'printpage' element
            printContainer.innerHTML = printPageElement.innerHTML;

            // Add the date information
            const printDateDiv = document.createElement('div');
            printDateDiv.innerHTML = `<p style="text-align: center; bottom:10px;">Printed on: ${new Date().toLocaleString()} By Marketing | VERSİON: 1.0.1</p>`;
            printContainer.appendChild(printDateDiv);

            // Replace 'printContents' with 'originalContents'
            const originalContents = document.body.innerHTML;
            document.body.innerHTML = printContainer.innerHTML;

            // Print the new content
            popupWindow.print();

            // Restore the original content
            document.body.innerHTML = originalContents;

            // Close the popup window
            popupWindow.document.close();
        }
    };
    const fetchDataInComponents = () => {
        window.location.reload();
    };

    const getOrders = async (billId) => {
        try {
            const response = await axios.post(
                `${CONN_KEY}app123/WebReserv/getBills.php`,
                { billId: billId },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    withCredentials: false
                }
            );

            if (response.data?.success && response.data?.data?.orders) {
                // Store the complete order data
                setOrders(response.data.data);
                setSelectedBillId(response.data.data.id);
                setIsOrdersModalVisible(true);
            } else {
                message.warning('No orders found');
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
            message.error('Failed to fetch orders. Please try again later.');
        }
    };

    const orderColumns = [
        {
            title: 'Product',
            dataIndex: 'product',
            key: 'product',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Price (₼)',
            dataIndex: 'price',
            key: 'price',
            render: (price) => `₼${price}`
        },
        {
            title: 'Total (₼)',
            key: 'total',
            render: (_, record) => `₼${(parseFloat(record.price) * record.quantity).toFixed(2)}`
        }
    ];

    const printThermalBill = (orderData) => {
        try {
            const adminName = localStorage.getItem('username') || 'Unknown Admin';
            const formatLine = (text, length = 32) => text.padEnd(length, ' ');
            const formatPrice = (price) => `₼${parseFloat(price).toFixed(2)}`.padStart(8, ' ');

            // Create the bill content with admin info at top
            let billContent = [
                '--------------------------------',
                '------ Reservation Copy --------',
                '--------------------------------',
                `${formatLine('Printed By Admin: ' + adminName)}`,
                `${formatLine('Print Time: ' + new Date().toLocaleString())}`,
                '--------------------------------',
                `${formatLine('Table: ' + orderData.Masa)}`,
                `${formatLine('Date: ' + new Date(orderData.selectedDay).toLocaleDateString())}`,
                `${formatLine('Time: ' + orderData.selectedTime)}`,
                `${formatLine('Customer: ' + orderData.username + ' ' + orderData.surename)}`,
                `${formatLine('Staff: ' + orderData.worker_name + ' ' + orderData.worker_surname)}`,
                '--------------------------------',
                '------------ ORDERS ------------',
                '--------------------------------'
            ];

            // Add each order item
            orderData.orders.forEach(item => {
                const quantity = item.quantity.toString().padStart(2, ' ');
                const product = item.product.substring(0, 20).padEnd(20, ' ');
                const price = formatPrice(item.price);
                const total = formatPrice(item.price * item.quantity);

                billContent.push(`${quantity} x ${product}`);
                billContent.push(`${' '.repeat(24)}${total}`);
            });

            billContent.push('--------------------------------');
            billContent.push(`${formatLine('Total Amount:', 24)}${formatPrice(orderData.totalAmount)}`);
            billContent.push('--------------------------------');
            billContent.push('*Service charge is not included');
            billContent.push(`Printed: ${new Date().toLocaleString()}`);
            billContent.push('\n\n\n'); // Paper feed

            // Create the print record
            const newPrintRecord = {
                printedBy: adminName,
                printTime: new Date().toLocaleString(),
                timestamp: Date.now(), // For sorting
                tableNo: orderData.Masa,
                customer: `${orderData.username} ${orderData.surename}`,
                totalAmount: orderData.totalAmount,
                orderId: orderData.id,
                orders: orderData.orders
            };

            // Save to Firebase
            const newPrintRef = ref(database, `printHistory/${orderData.id}_${Date.now()}`);
            set(newPrintRef, newPrintRecord)
                .then(() => {
                    console.log('Print history saved to Firebase');
                    // Update local state
                    setPrintHistory(prev => [newPrintRecord, ...prev].slice(0, 10));
                })
                .catch(error => {
                    console.error('Error saving print history:', error);
                });

            // Create the print window with both sections
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Bill Print</title>
                    <style>
                        @page {
                            size: 80mm auto;
                            margin: 0;
                        }
                        body {
                            font-family: 'Courier New', monospace;
                            font-size: 12px;
                            line-height: 1.2;
                            padding: 5mm;
                            margin: 0;
                            width: 70mm;
                        }
                        pre {
                            margin: 0;
                            white-space: pre-wrap;
                        }
                        .print-history {
                            margin-top: 20mm;
                            border-top: 1px dashed #000;
                            padding-top: 5mm;
                        }
                        .history-title {
                            font-weight: bold;
                            text-align: center;
                            margin-bottom: 3mm;
                        }
                        .history-item {
                            border-bottom: 1px dotted #ccc;
                            padding: 2mm 0;
                        }
                    </style>
                </head>
                <body>
                    <pre>${billContent.join('\n')}</pre>
                    <div class="print-history">
                        <div class="history-title">Print History</div>
                        ${printHistory.map(record => `
                            <div class="history-item">
                                <div>Printed by: ${record.printedBy}</div>
                                <div>Time: ${record.printTime}</div>
                                <div>Table: ${record.tableNo}</div>
                                <div>Customer: ${record.customer}</div>
                                <div>Amount: ₼${record.totalAmount}</div>
                            </div>
                        `).join('')}
                    </div>
                </body>
                </html>
            `);

            // Wait for content to load then print
            printWindow.document.close();
            printWindow.onload = function () {
                printWindow.focus();
                printWindow.print();
                setTimeout(() => {
                    printWindow.close();
                }, 1000);
            };

            message.success('Bill sent to printer');
        } catch (error) {
            console.error('Print error:', error);
            message.error('Failed to print bill');
        }
    };

    // Add this useEffect to load print history when component mounts
    useEffect(() => {
        // Reference to print history in Firebase
        const historyRef = ref(database, 'printHistory');

        // Listen for changes in print history
        const unsubscribe = onValue(historyRef, (snapshot) => {
            if (snapshot.exists()) {
                const historyData = snapshot.val();

                // Convert object to array and sort by timestamp
                const historyArray = Object.values(historyData)
                    .sort((a, b) => b.timestamp - a.timestamp)
                    .slice(0, 10); // Keep only last 10 records

                setPrintHistory(historyArray);
            }
        });

        // Cleanup subscription
        return () => unsubscribe();
    }, []);

    return (
        <Layout >
            <Header className="inset-x-0 top-0 z-50 bg-[#000910] flex flex-row flex-nowrap justify-between items-center">
                <Link to={"/Main"}>
                    <img
                        className="w-auto h-8 cursor-pointer"
                        src={logo}
                        alt="logo"
                    />
                </Link>
                <div className="flex items-center gap-5">
                    <Button className="p-2 bg-blue-50" onClick={fetchDataInComponents}>
                        <SyncOutlined spin />
                    </Button>
                    <Button
                        className="p-2 bg-blue-50"
                        onClick={sendToFirebase}
                    >
                        red
                    </Button>
                    <Button className="p-2 bg-blue-50" >
                        <a href={`/3d`}> 3D</a>
                    </Button>
                    <Button className="buttonprint bg-blue-50" target="_blank" onClick={handlePrintExtra}>
                        Print Extra
                    </Button>
                    <Button className="buttonprint bg-blue-50" target="_blank" onClick={handlePrintEllips}>
                        Print Ellips
                    </Button>
                    <Button className="buttonprint bg-blue-50" target="_blank" onClick={handlePrintEllips}>
                        Print Europe
                    </Button>
                    <Headers />
                </div>
            </Header>
            <Content className="site-layout ">
                <div style={{ padding: 24, minHeight: 380, background: colorBgContainer }}>
                    <div className='infosds'>
                        <div className='ckdj'>
                            <div className="redbox" />-
                            <p style={{ fontSize: '16px' }}>Rezerv edilib</p>
                        </div>
                        <div className='ckdj'>
                            <div className="greenbox" />-
                            <p style={{ fontSize: '16px' }}>Imtina edilib</p>
                        </div>
                        <div className='ckdj'>
                            <div className="greenboxBorder" />-
                            <p style={{ fontSize: '16px' }}>Boş Masalar</p>
                        </div>
                        <StatUSer />
                        <StatСancels />
                        <QueueList />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'flex-start', flexDirection: 'row', gap: '10px' }}>
                        <Table
                            columns={columns}
                            dataSource={data}
                            loading={isLoading}
                            rowKey="id"
                            rowSelection={{
                                type: 'radio', // Allows selecting only one row
                                onChange: (selectedRowKeys, selectedRows) => {
                                    setSelectedRow(selectedRows[0]); // Update selected row
                                },
                            }}
                            pagination={{ pageSize: 5 }}
                        />
                    </div>
                    <Tabbar />
                    <Drawer
                        title="Basic Drawer"
                        placement="right"
                        onClose={onClose}
                        open={open}
                    >
                    </Drawer>
                    <Modal
                        title="Permission"
                        open={isModalopen}
                        onOk={() => handleModalSubmit(selectedReason)} // Remove 'rejected' argument
                        onCancel={() => setIsModalopen(false)}
                        destroyOnClose
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                        okText="İmtina et"
                        cancelText="Cancel"
                    >
                        <p>İstifadəçiyə ləğvetmə icazəsi vermək istədiyinizə əminsiniz <b>{selectedRecord?.username} {selectedRecord?.surename} {selectedRecord?.Masa}</b>?</p>
                        <Input
                            type="text"
                            value={selectedReason}
                            rules={[
                                {
                                    required: true,
                                    message: "Zəhmət olmasa imtina səbəbini qeyd edin!",
                                },
                            ]}
                            placeholder="İmtina səbəbini qeyd edin"
                            onChange={(e) => setSelectedReason(e.target.value)}
                        />
                    </Modal>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            alignItems: 'flex-start',
                            flexDirection: 'row',
                            gap: '10px'
                        }}>
                        {/* <AutoSizer>
                            {({ height, width }) => (
                                <ReactSVGPanZoom
                                    width={width}
                                    height={height}
                                    ref={viewerRef}
                                    tool={tool}
                                    onChangeTool={setTool}
                                    value={value}
                                    onChangeValue={setValue}
                                    background="#FFF"
                                    detectAutoPan={false}
                                > */}
                        <MapC />
                        <MapM2 />
                        <MapEurope />
                        {/* <MapM1ellips />
                        <MapM2ellips />
                        <MapM3ellips /> */}
                        {/* </ReactSVGPanZoom>
                            )}
                        </AutoSizer> */}
                    </div>
                    <Modal
                        title={`Orders for Table ${selectedBillId}`}
                        open={isOrdersModalVisible}
                        onCancel={() => setIsOrdersModalVisible(false)}
                        footer={[
                            <Button
                                key="print"
                                type="primary"
                                icon={<PrinterOutlined />}
                                onClick={() => printThermalBill(orders)}
                            >
                                Print Bill
                            </Button>,
                            <Button key="close" onClick={() => setIsOrdersModalVisible(false)}>
                                Close
                            </Button>
                        ]}
                        width={800}
                    >
                        <div style={{ marginBottom: 16 }}>
                            <Table
                                columns={orderColumns}
                                dataSource={orders?.orders || []}
                                pagination={false}
                                scroll={{ y: 400 }}
                                summary={(pageData) => {
                                    const total = pageData.reduce((acc, current) =>
                                        acc + (parseFloat(current.price) * current.quantity), 0
                                    );

                                    return (
                                        <Table.Summary fixed>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell index={0} colSpan={3}>
                                                    <strong>Total Amount</strong>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell index={1}>
                                                    <strong>₼{total.toFixed(2)}</strong>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                        </Table.Summary>
                                    );
                                }}
                            />

                            {/* Print History Section */}
                            {printHistory.length > 0 && (
                                <div style={{ marginTop: 24, borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
                                    <h3>Print History</h3>
                                    <Table
                                        dataSource={printHistory}
                                        pagination={false}
                                        size="small"
                                        columns={[
                                            {
                                                title: 'Printed By',
                                                dataIndex: 'printedBy',
                                                key: 'printedBy',
                                            },
                                            {
                                                title: 'Time',
                                                dataIndex: 'printTime',
                                                key: 'printTime',
                                            },
                                            {
                                                title: 'Table',
                                                dataIndex: 'tableNo',
                                                key: 'tableNo',
                                            },
                                            {
                                                title: 'Customer',
                                                dataIndex: 'customer',
                                                key: 'customer',
                                            },
                                            {
                                                title: 'Amount',
                                                dataIndex: 'totalAmount',
                                                key: 'totalAmount',
                                                render: (amount) => `₼${amount}`
                                            }
                                        ]}
                                    />
                                </div>
                            )}

                            <div style={{ marginTop: 16, color: '#666' }}>
                                *Service charge is not included in the price
                            </div>
                        </div>
                    </Modal>
                </div>
            </Content>
            <Footers />
        </Layout>
    );
};
export default Mapmain;